function AppointmentDetailWS(parent) {
  // super
  AbstractWS.call(this, parent);

  this.name = "AppointmentDetailWS";

  this.appointmentId = ko.observable(null);

  this.serviceURL = ko.computed(function () {
    return "/qless/api/v1/appointment/" + this.appointmentId();
  }, this);


}

AppointmentDetailWS.prototype = Object.create(AbstractWS.prototype);

AppointmentDetailWS.prototype.reset = function () {
  this.appointmentId(null);
  AbstractWS.prototype.reset.call(this)
}

AppointmentDetailWS.prototype.requestAppointment = function (appointmentId, callback) {
  this.reset()
  this.appointmentId(appointmentId)
  this.doRequest(callback);
}
